// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero__1wBpZ","link":"link__2J6bA","section":"section__2WId5","c":"c__D-O7M","subtitle":"subtitle__3-NDJ","image":"image__8n5ll","buttons":"buttons__3jOE1"};